import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/book-a-room')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_layout/book-a-room"!</div>
}
